@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
//vars
$bf_bg1: #080808;//to change
$bf_bg2: #161616;
$bf_bg3: #262626;
$bf_icon: #e5e5e5c0;
$bf_accent: #F16522;//to change
$bf_border_clr: #55555555;//to change
$bf_border: 1px solid $bf_border_clr;//to change
$bf_border2: 1px solid rgba($bf_icon,.5);//to change
$bf_p: #dedede;//to change
$bf_borderrad: .35rem;//to change
#bf_appwrapper {
  *,&{
    -ms-overflow-style: none;
    scrollbar-width: none;
    box-sizing: border-box;
    // position: relative;
    &::-webkit-scrollbar { 
      display: none;
    }
  }
  position: absolute;
  height: 100%;
  width: 100%;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  background: $bf_bg1;
  padding: 3px;
  box-sizing: content-box;
  .panel {
    height: 100%;
    overflow: hidden auto;
    // background: pink;
    width: calc(100% - 3rem);
    top: 50%;
    right: 0%;
    // background: pink;
    position: absolute;
    translate: 0% -50%;
    padding: 1rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    #HomepageTabs {
      width: 100%;
      height: fit-content;
      min-height: 5rem;
      // background: pink;
      margin-top: .5rem;
      .hpp {
        width: 100%;
        height: fit-content;
        min-height: 5rem;
        // background: pink;
        padding: 1rem 0;
      }
      .hpl {
        width: 100%;
        height: 2rem;
        // background: pink;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        position: relative;
        // flex-direction: row;
        border-bottom: $bf_border;
        .hpi {
          background: $bf_accent;
          height: 2px;
          width: var(--active-tab-width);
          translate: 0% 1px;
          left: var(--active-tab-left);
          bottom: 0%;
          position: absolute;
        }
        .hptab {
          width: fit-content;
          height: 100%;
          padding: .5rem 1rem;
          box-sizing: border-box;
          line-height: 0;
          text-align: center;
          vertical-align: middle;
          display: flex;
          justify-content: center;
          align-items: center;
          background: transparent;
          border: none;
          outline: none;
          color: $bf_p;
          font-size: .875rem;
        }
      }
    }
    .bf_topBar {
      height: 2.5rem;
      width: 100%;
      // background: pink;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      #userAccount {
        width: 150px;
        height: calc(100% - .5rem);
        background: $bf_bg3;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        padding: .5rem;
        gap: .5rem;
        #userProfilePicture {
          height: 1rem;
          aspect-ratio: 1 / 1;
          background: white;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
        }
        #userName {
          color: $bf_p;
          font-size: .875rem;
        }
      }
      .seperator {
        height: calc(100% - .5rem);
        $sepMarg: .5rem;
        
        width: calc($sepMarg * 1.5);
        // background: pink;
        margin-left: $sepMarg;
        border-left: $bf_border;
      }
      #searchbarWrapper {
        width: fit-content;
        height: 100%;
        padding: .25rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-grow: 1;
        position: relative;
        #icon {
          color: $bf_icon;
          position: absolute;
          left: .5rem;
          font-size: 1rem;
          // background: pink;
          top: 50%;
          translate: 0% -50%;
          height: 1.5rem;
          aspect-ratio: 1 / 1;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          vertical-align: middle;
          line-height: 0;
          z-index: 9;
        }
        input {
          height: 100%;
          width: 100%;
          background: $bf_bg3;
          // border: $bf_border;
          border: none;
          outline: none;
          padding: .5rem;
          color: $bf_p;
          padding-left: 2rem;
          font-size: .875rem;
          ::placeholder {
            color: $bf_icon;
          }
        }
      }
      #mclogo {
        width: 150px;
        height: 2rem;
        // translate: 0% 12.5%;
        background-image: url("/apps/beanforged/eagl.png");
        background-size: contain;
        scale: 1.1;
        background-position: top center;
        background-repeat: no-repeat;
      }
    }
  }
  #bf_sidebar {
    height: 100%;
    width: 3rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 0%;
    top: 50%;
    translate: 0% -50%;
    // gap: .5rem;
    // padding: .5rem;
    background: $bf_bg2;
    #spacer {
      flex-grow: 1 !important;
    }
    #indicator {
      width: calc(100%);
      position: absolute;
      top: var(--active-tab-top);
      left: 50%;
      translate: -50% 0%;
      aspect-ratio: 1 / 1;
      background: #ffffff15;
      transition: .35s;
    }
    .bf_sb_icon {
      width: 100%;
      aspect-ratio: 1 / 1;
      background: transparent;
      border: none;
      display: flex;
      justify-content: center;
      position: relative;
      align-items: center;
      text-align: center;
      vertical-align: middle;
      line-height: 0;
      cursor: pointer;
      font-size: 1.25rem;
      color: $bf_icon;
      border-radius: 50%;
      // margin-bottom: .5rem;
      .icon {
        position: absolute;
        top: 50%;
        left: 50%;
        translate: -50% -50%;
      }
    }
  }
  * {
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
    font-optical-sizing: auto;
    font-weight: 300;
    font-style: normal;
  }
  .settingsInfo {
    color: $bf_p;
    opacity: .75;
    width: 100%;
    height: fit-content;
    font-size: .875rem;
    // background: green;
  }
}
#mpt_toolbar {
  height: 2rem;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  .button {
    width: fit-content;
    height: 100%;
    padding: .5rem 0;
    background: transparent;
    border: none;
    outline: none;
    font-size: .875rem;
    color: $bf_p;
    transition: .35s;
    cursor: pointer;
    &.b2 {
      background: $bf_bg3;
      padding: .5rem 2rem !important;
    }
  }
}
.backdrop {
  height: 100%;
  width: 100%;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  position: absolute;
  background: #00000090;
  backdrop-filter: blur(.5rem);
  opacity: 1;
  transition: 1s;
  z-index: 99;
  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
  }
}
.popup {
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24rem;
  max-width: calc(100% - 3rem);
  margin-top: -2rem;
  padding: 1.5rem;
  z-index: 159;
  background-color: $bf_bg2;
  color: $bf_p;
  transition: all 150ms;
  touch-action: none;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: .5rem;
  p {
    font-size: .875rem;
    opacity: .8;
  }
  #file {
    display: none;
    visibility: hidden;
    height: 0;
    width: 0;
  }
  #text {
    width: 10rem;
    flex-grow: 1;
    height: 100%;
    padding: .5rem;
    background: $bf_bg3;
    border: none;
    outline: none;
    color: $bf_p;
  }
  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }
}
.rowWrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  gap: .5rem;
  width: 100%;
  max-width: 100%;
}
#instances{
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: .5rem;
  .instanceWrapper {
    min-width: 6rem;
    max-width: 8.5rem;
    width: auto;
    flex: 1;
    aspect-ratio: 17.5 / 25;
    background: $bf_bg3;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: .5rem;
    position: relative;
    .version {
      top: .25rem;
      right: .25rem;
      padding: .125rem .25rem;
      position: absolute;
      background: #00000090;
      font-size: .75rem;
      color: $bf_p;
      color: #e0e0e0;
      width: fit-content;
      height: fit-content;
      z-index: 80;
    }
    .action {
      height: .75rem;
      aspect-ratio: 1 / 1;
      padding: 0 !important;
      line-height: 0;
      font-size: .75rem;
      color: $bf_p;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
    }
    .h1 {
      font-size: .875rem;
      color: $bf_p;
      padding: 0 .5rem;
      overflow: hidden;
      text-wrap: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      background: transparent;
      border: none;
      text-align: left;
    }
    .cover {
      width: 100%;
      aspect-ratio: 1 / 1;
      background: #fff;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}
.ttpopup {
  box-sizing: border-box;
  font-size: 0.875rem;
  line-height: 1.25rem;
  display: flex;
  flex-direction: column;
  padding: .5rem .65rem;
  background-color: $bf_bg3 !important;
  filter: drop-shadow(0 0 5px rgba($bf_bg1,.5));
  color: $bf_p;
  transform-origin: var(--transform-origin);
  z-index: 999;
  transition:
    transform 150ms,
    opacity 150ms;
  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
    transform: scale(0.9);
  }
  &[data-instant] {
    transition: none;
  }
}
.bflstxt {
  color: $bf_p;
  font-size: .875rem;
  animation: 2s flash infinite;
}
@keyframes flash{
  0%{opacity:1;}
  50%{opacity:0;}
  100%{opacity:1;}
}